import { styled, Typography } from '@mui/material';

export const RegistryDashboardWrapper = styled('div')({
  margin : '57px 0',
});

export const Header = styled('div')({
  display        : 'flex',
  justifyContent : 'space-between',
  alignItems     : 'center',
  marginBottom   : '13px',
});

export const Title = styled(Typography)({
  fontFamily    : 'Montserrat',
  fontWeight    : '700',
  textTransform : 'uppercase',
});

export const RegistryDashboardContent = styled('div')(({ theme }) => ({
  margin     : '24px auto',
  background : theme.palette.primary.white,
  padding    : '20px 50px',
  display    : 'flex',
  '> div'    : {
    flex : '1',
  },
}));

export const HeatmapContainer = styled('div')(({ theme }) => ({}));

export const PieChartContainer = styled('div')(({ theme }) => ({
  display        : 'flex',
  justifyContent : 'center',
  alignItems     : 'center',
}));

export const Legend = styled('div')({
  '& >div' : {
    display    : 'flex',
    alignItems : 'center',
    gridGap    : '2px',
  },
});

export const CircleIcon = styled('div')(({ isHighlihgted }) => ({
  height          : 8,
  width           : 8,
  backgroundColor : isHighlihgted ? '#00778B' : '#BDBDBD',
  borderRadius    : '50%',
}));
